
import { addExchangeUserApi, deleteUserExchangeApi, getExchangeUserApi, getUserAccountApi } from "../components/constant/api";
import { myApi } from "./api";

export const userExchangeApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    setUserExchnageApi: builder.mutation({
      query: (post) => ({
        url: addExchangeUserApi,
        method: "POST",
        body:post
      }),
      invalidatesTags: (_) => ["user","userapi"],
    }),
    deleteUserExchangeApi: builder.mutation({
      query: (post) => ({
        url: deleteUserExchangeApi+"/"+post.id,
        method: "DELETE",
      }),
      invalidatesTags: (_) => ["user","userapi"],
    }),
    getUserExchnageApi: builder.query({
      query: () => ({
        url: getExchangeUserApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["userapi"],
    }),
    getUserAccount: builder.query({
      query: () => ({
        url: getUserAccountApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["userapi"],
    }),
  }),
});

export const {useSetUserExchnageApiMutation,useGetUserExchnageApiQuery,useGetUserAccountQuery,useDeleteUserExchangeApiMutation} = userExchangeApi;